import Box from "@mui/material/Box"
import { ReactNode } from "react"
import { makeStyles } from "tss-react/mui-compat"

interface IImageBackgroundStyles {
  url: string
}

const useStyles = makeStyles<{
  url: string
}>()(
  (theme, props) => ({
    root: {
      display: "flex",
      position: "relative",
      backgroundImage: `url(${props.url})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      width: "100%",
      borderRadius: "10px 10px 0 0",
      [theme.breakpoints.down("lg")]: {
        height: "202px",
      },
      [theme.breakpoints.up("md")]: {
        height: "428px",
      },
    },
    bottom: {
      display: "flex",
      height: "100%",
      width: "100%",
      background: "linear-gradient(180deg, rgba(78, 86, 89, 0) 0%, #262b2d 100%)",
      justifyContent: "space-between",
      alignItems: "flex-end",
      padding: "10px",
      flexDirection: "row-reverse",
    },
  }),
)

interface IImageBackground extends IImageBackgroundStyles {
  children?: ReactNode
}

const ImageBackground = ({ url, children }: IImageBackground) => {
  const styleProps = {
    url,
  }

  const { classes } = useStyles(styleProps)

  return (
    <Box className={classes.root}>
      <Box className={classes.bottom}>{children}</Box>
    </Box>
  )
}

export default ImageBackground
